(function (Drupal) {
  'use strict';

  Drupal.behaviors.ouigoFooter = {
    attach: function (context) {
      // Custom footer behaviors can be added here if needed in the future.
    }
  };

})(Drupal);
